// MUST be first: seeds goober's nonced <style> before react-hot-toast (and its
// module-eval goober styles) load, so toast CSS passes the nonce-based style-src CSP.
import './Utils/gooberNonce';
import React from 'react';
import ReactDOM from 'react-dom';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import App from './App';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import * as ServiceWorker from './serviceWorker';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { CSP_NONCE } from './Utils/cspNonce';
import './Utils/branding';
import { loadClarity } from './Utils/clarity';
import './Utils/locales/i18n';

// Bind MUI v6 / emotion's injected <style> tags to the CSP nonce so style-src can
// drop 'unsafe-inline'. MUI v4 (JSS) auto-reads the <meta name="csp-nonce"> tag.
const emotionCache = createCache({ key: 'css', nonce: CSP_NONCE });

loadClarity();

ReactDOM.render(
	<CacheProvider value={emotionCache}>
		<App />
	</CacheProvider>
	, document.getElementById('root'));
if ("serviceWorker" in navigator) {
	navigator.serviceWorker
		.register("/firebase-messaging-sw.js")
		.then(function (registration) {
			console.log("Registration successful, scope is:", registration.scope);
		})
		.catch(function (err) {
			console.log("Service worker registration failed, error:", err);
		});

	ServiceWorker.register({
		onUpdate: reg => {
			const waitingServiceWorker = reg.waiting
			waitingServiceWorker.addEventListener("statechange", event => {
				if (event.target.state === "activated") {
					console.log("Updated")
				}
			});
			waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
		}
	})
}

